import { render, staticRenderFns } from "./DetailsSectionKPO.vue?vue&type=template&id=654ae574&"
import script from "./DetailsSectionKPO.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionKPO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports